import React from "react";

type MarketingConsentFieldsProps = {
  idPrefix: string;
  phoneMarketing: boolean;
  electronicMarketing: boolean;
  onPhoneMarketingChange: (checked: boolean) => void;
  onElectronicMarketingChange: (checked: boolean) => void;
};

export const marketingConsentLabels = {
  phone:
    "Wyrażam zgodę na kontakt telefoniczny w celu marketingu bezpośredniego usług Expert Partner.",
  electronic:
    "Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną.",
} as const;

export function FormPrivacyNotice() {
  return (
    <p className="form-privacy-notice">
      Administratorem danych jest Expert Partner Sp. z o.o. Dane przetwarzamy
      wyłącznie, aby odpowiedzieć na zapytanie i obsłużyć kontakt. Przysługują
      Ci prawa opisane w{" "}
      <a href="/polityka-prywatnosci">polityce prywatności</a>.
    </p>
  );
}

export function MarketingConsentFields({
  idPrefix,
  phoneMarketing,
  electronicMarketing,
  onPhoneMarketingChange,
  onElectronicMarketingChange,
}: MarketingConsentFieldsProps) {
  return (
    <fieldset className="marketing-consents">
      <legend>Dobrowolne zgody marketingowe</legend>
      <label
        className="privacy-choice optional"
        htmlFor={`${idPrefix}-marketing-phone`}
      >
        <input
          id={`${idPrefix}-marketing-phone`}
          type="checkbox"
          checked={phoneMarketing}
          onChange={event => onPhoneMarketingChange(event.target.checked)}
        />
        <span>
          {marketingConsentLabels.phone} Zgodę można wycofać w dowolnym
          momencie.
        </span>
      </label>
      <label
        className="privacy-choice optional"
        htmlFor={`${idPrefix}-marketing-electronic`}
      >
        <input
          id={`${idPrefix}-marketing-electronic`}
          type="checkbox"
          checked={electronicMarketing}
          onChange={event => onElectronicMarketingChange(event.target.checked)}
        />
        <span>
          {marketingConsentLabels.electronic} Zgodę można wycofać w dowolnym
          momencie.
        </span>
      </label>
    </fieldset>
  );
}
